import Fit from './Fit.js';
export { Fit };
export default Fit;
